export const companyAddress = {
  address1: 'ul. Hausbrandta 32/37',
  address2: '80-126 Gdańsk, Poland',
  tel: '+48 664 023 815',
  companyMail: 'contact@thegoodcode.io'
}
